import api from './api';

export const patientDocumentService = {
  uploadDocument: async (formData) => {
    const response = await api.post('/patient-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  uploadPhoto: async (formData) => {
    const response = await api.post('/patient-documents/upload-photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getPatientDocuments: async (uhid) => {
    const response = await api.get(`/patient-documents/patient/${encodeURIComponent(uhid)}`);
    return response.data;
  },

  getLedgerDocuments: async (ledgerNo) => {
    const response = await api.get(`/patient-documents/ledger/${encodeURIComponent(ledgerNo)}`);
    return response.data;
  },

  deleteDocument: async (documentId) => {
    const response = await api.delete(`/patient-documents/${documentId}`);
    return response.data;
  },

  getDocumentViewUrl: (documentId) => {
    return `${api.defaults.baseURL}/patient-documents/${documentId}/view`;
  },

  getDocumentDownloadUrl: (documentId) => {
    return `${api.defaults.baseURL}/patient-documents/${documentId}/download`;
  },
};

export default patientDocumentService;
